import * as React from "react";
import classNames from "classnames";
import { WithStyles, withStyles, createStyles, Theme } from 'components/controls/styles';
import { Divider, Grid } from "components/controls/widget";

import DivBox from "./DivBox";

declare type XSType = undefined | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;

export interface DetailGridItem {
    show?: boolean;
    divider?: boolean;
    title?: boolean;
    group?: boolean;
    label?: React.ReactNode;
    content?: React.ReactNode;
}

export interface DetailGridProps {
    items: DetailGridItem[];
    labelXS?: XSType;
}

const DetailGrid = (props: DetailGridProps & WithStyles<typeof styles>) => {

    const { items, classes, labelXS } = props;

    const getItem = (i: DetailGridItem, k: number) => {

        const lblClass = classNames([
            { [classes.root]: true },
        ]);

        if (labelXS !== undefined) {

        }
        const contentXS: XSType = (12 - labelXS) as XSType;

        return <Grid key={k} container justify="space-between" spacing={8}>
            <Grid item xs={labelXS || 3}><DivBox label>{i.label}</DivBox></Grid>
            <Grid item xs={contentXS || 9}><DivBox>{i.content}</DivBox></Grid>
        </Grid>
    }

    const getContent = (i: DetailGridItem, k: number) => {

        if (i.show === false)
            return null;

        if (i.divider === true)
            return <DivBox key={k}><Divider /></DivBox>

        if (i.title === true)
            return <DivBox key={k}>{i.label}</DivBox>

        if (i.group === true)
            return <Grid key={k} container direction="column" wrap="nowrap">
                <Grid item ><DivBox>{i.label}</DivBox></Grid>
                <Grid item ><DivBox nested>{i.content}</DivBox></Grid>
            </Grid>

        return getItem(i, k);
    }

    return <Grid container direction="column" wrap="nowrap">
        <Grid item>
            {items.map((i, k) => getContent(i, k))}
        </Grid>
    </Grid>
}



export const styles = (theme: Theme) => createStyles({
    root: {
        padding: 5,
    },
    row: {

    },
    label: {

    },
    lighter: {
        fontWeight: 'lighter'
    },
    bolder: {
        fontWeight: 'bolder'
    }
});


export default withStyles(styles)(DetailGrid);
